import { useState } from "react";
import { useNavigate } from "react-router-dom";

import SharedHeader from "@/components/SharedHeader";
import PricingPlans from "@/components/PricingPlans";
import { apiClient } from "@/api/client";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/AuthContext";

export default function PaywallPage() {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    const handleSelectPlan = async (planKey: string) => {
        setIsLoading(true);
        setError(null);
        try {
            const { checkout_url } = await apiClient.createCheckoutSession(planKey);
            window.location.href = checkout_url;
        } catch (err) {
            console.error("Failed to create checkout session", err);
            setError("Something went wrong starting the checkout. Please try again.");
            setIsLoading(false);
        }
    };

    // If user is already active, redirect to episodes
    if (user?.subscription_status === "active") {
        navigate("/episodes", { replace: true });
        return null;
    }

    return (
        <div className={cn("min-h-screen", theme.colors.backgroundCream)}>
            <SharedHeader />

            <main className="mx-auto max-w-7xl px-6 py-16 pt-24">
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-5xl font-black mb-6 text-gray-900 dark:text-white">
                        You're Almost There
                    </h1>
                    <p className="text-xl text-gray-700 dark:text-gray-300 max-w-2xl mx-auto">
                        Pick a plan to start chatting with your podcasts. Cancel anytime with one click.
                    </p>
                </div>

                {error && (
                    <div className="max-w-md mx-auto mb-8 p-4 bg-red-50 border border-red-200 rounded-xl text-red-600 text-center">
                        {error}
                    </div>
                )}

                <PricingPlans
                    onSelectPlan={handleSelectPlan}
                    isLoading={isLoading}
                    ctaText="Subscribe Now"
                />
            </main>
        </div>
    );
}
